import {SchedulerReoccurrence} from "./x-enums/scheduler-reoccurrence";
import {CalculationType} from "./x-enums/calculation-type";
import {TypeOrder} from "./x-enums/type-order";
import {CalculationOperation} from "./x-enums/calculation-operation";
import {CalculationTargetType} from "./x-enums/calculation-target-type";
import {TimeUtilities} from "../../../utils/time-utilities";
import {RoundingType} from "./x-enums/rounding-type";

/** Default gap between the pre-filled start and end of a new automation, in minutes. */
export const DEFAULT_SCHEDULER_WINDOW_MINUTES = 60;

export class NewSchedulerGroup {
  schedulerReoccurrence: SchedulerReoccurrence | undefined;
  calculationType: CalculationType | undefined;
  typeOrder: TypeOrder | undefined;
  calculationOperation: CalculationOperation | undefined;
  interval: number = 10;
  firstStr: string = TimeUtilities.dateToString(new Date());
  roundingType: RoundingType = RoundingType.None;
  get first(): Date {
    return new Date(this.firstStr)
  }

  /**
   * The **"Ende" input's** value. Pre-filled one hour AFTER the start, never at the same instant (#449).
   *
   * Both fields used to default to `new Date()`, so a user who set only the start submitted a group whose `last`
   * was already in the past — the reported request carried `first` 19:00 and `last` 18:56. Harmless for a `Once`
   * group, but a `Reoccurring` one deactivates itself on its first run, because `SchedulerGroupHandler.Execute`
   * computes the next occurrence and compares `next > group.Last`.
   *
   * Read {@link last}, not this field, for the value that is submitted: the input is only rendered for a
   * `Reoccurring` group, so for a `Once` group this string is a default nobody can see or change (#488).
   */
  lastStr: string = TimeUtilities.dateToString(
    new Date(Date.now() + DEFAULT_SCHEDULER_WINDOW_MINUTES * 60 * 1000));

  /**
   * The end of the window this group actually has — the value submitted as `Last`.
   *
   * For a `Reoccurring` group that is whatever the user typed into "Ende". For a **`Once`** group it is the
   * start: the wizard states the semantics itself ("Einmalig: Ausführung zum Startzeitpunkt"), renders no "Ende"
   * input at all, and the server never consults `Last` on the once-path — `SchedulerGroupHandler.SaveAndSchedule`
   * schedules the single job at `group.First` and `Execute` deactivates the group unconditionally afterwards.
   * Collapsing the window here keeps the stored record self-describing (a group whose last execution *is* its
   * first) instead of carrying an hour-long window the user never asked for, and it is what makes the #449 guard
   * scopable to `Reoccurring` in `AutomationManagerComponent.sendSchedulerGroup` (#488 — a start more than an
   * hour out tripped a guard about a field that is not on screen, and the automation could not be saved at all).
   *
   * `lastStr` is deliberately left untouched, so switching the wizard back to `Intervall` still shows the
   * pre-filled end rather than a window collapsed onto the start.
   */
  get last(): Date {
    return this.schedulerReoccurrence === SchedulerReoccurrence.Once ? this.first : new Date(this.lastStr);
  }
  calculationValues: number[] = [];
  additionalIds: any = {};
  targetIds: string[] = [];
  calculationTargetType: CalculationTargetType | undefined;
}
